import useApp from "hooks/useApp";
import useMessages from "hooks/useMessages";
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { markChatMessageReceiptsAsRead } from 'store/messages/messages.actions';
const isNearOrAtBottom = (container: HTMLElement) => {
    const scrollAllowance = 500;
    const isScrollable = container.scrollHeight > container.clientHeight;
    const isNearBottom = container.scrollTop >= (container.scrollHeight - container.offsetHeight - scrollAllowance)
    return !isScrollable || isNearBottom
}

const scrollToBottom = (container: HTMLElement) => {
    container.scrollTop = container.scrollHeight
}

export const useNewMessageIndicator = () => {

    const messagesContainer = useRef<HTMLDivElement>(null);
    const [newMessageCount, setNewMessageCount] = useState(0);
    const messages = useMessages();
    const { showStartNewChatButton, ended, isAgentTyping, newMessageBubbleActive } = useApp();
    const [lastReadLength, setLastReadLength] = useState(messages.length);
    const dispatch = useDispatch();


    useEffect(() => {
        const container = messagesContainer.current;
        if (!container) return;

        const checkClearUnread = () => {            
            if (isNearOrAtBottom(container) && document.hasFocus()) {
                setNewMessageCount(0);
                setLastReadLength(messages.length)
                dispatch(markChatMessageReceiptsAsRead())
            }
        }

        checkClearUnread()

        container.addEventListener('scroll', checkClearUnread)
        window.addEventListener('focus', checkClearUnread)


        return () => {
            container.removeEventListener('scroll', checkClearUnread)
            window.removeEventListener('focus', checkClearUnread)

        }

    }, [messagesContainer, messages, dispatch])

    useLayoutEffect(() => {
        const container = messagesContainer.current!;

        if (isNearOrAtBottom(container) || !newMessageBubbleActive) return scrollToBottom(container);
        
        if (lastReadLength === messages.length) return;

        const newMessageCount =
            messages
                .slice(lastReadLength)
                .filter(msg => msg.role !== 'CUSTOMER')
                .length

        setNewMessageCount(newMessageCount)

    }, [messages, showStartNewChatButton, ended, lastReadLength, newMessageBubbleActive])

    useLayoutEffect(() => {
        const container = messagesContainer.current!;

        if (isNearOrAtBottom(container)  || !newMessageBubbleActive) scrollToBottom(container);

    }, [isAgentTyping, newMessageBubbleActive]);

    const onClickNewMessageIndicator = useCallback(() => {
        const container = messagesContainer.current!;
        container.scrollTop = container.scrollHeight;
    }, [])

    return {
        messagesContainer,
        newMessageCount,
        onClickNewMessageIndicator
    }

}